export class Auth
{
    public token:string;
    public papel:string;
    public nome:string;
    public vendedorId:string;
    public codTab: string;
    public promo: boolean;
    public isDistribuidor: boolean;

    public Assing(auth)
    {
        if (auth.token)
        {
            this.token = auth.token;
        }
        if (auth.papel)
        {
            this.papel = auth.papel;

        }
        if (auth.nome)
        {
            this.nome = auth.nome;
        }
        if (auth.vendedorId)
        {
            this.vendedorId = auth.vendedorId;
        }
        if (auth.promo)
        {
          this.promo = true;
        }
        this.isDistribuidor = auth.isDistribuidor === true;
        this.codTab = auth.codTab;
    }
}
